import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var DiscussionIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M19,3H5A2,2,0,0,0,3,5V8a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V5A2,2,0,0,0,19,3ZM13.5,8h-8a.5.5,0,0,1,0-1h8a.5.5,0,0,1,0,1Zm5,0h-3a.5.5,0,0,1,0-1h3a.5.5,0,0,1,0,1Zm0-2H5.5a.5.5,0,0,1,0-1h13a.5.5,0,0,1,0,1Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M6,8v3.5a.5.5,0,0,0,.85.35L10,8Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M18,8v3.5a.5.5,0,0,1-.85.35L14,8Z"
  }), /*#__PURE__*/_jsx("circle", {
    cx: "6.48",
    cy: "15.82",
    r: "1.77"
  }), /*#__PURE__*/_jsx("path", {
    d: "M6.5,18.47a3.54,3.54,0,0,0-3.5,3,.45.45,0,0,0,.44.5H9.56a.45.45,0,0,0,.44-.5A3.54,3.54,0,0,0,6.5,18.47Z"
  }), /*#__PURE__*/_jsx("circle", {
    cx: "17.48",
    cy: "15.82",
    r: "1.77"
  }), /*#__PURE__*/_jsx("path", {
    d: "M17.5,18.47a3.54,3.54,0,0,0-3.5,3,.45.45,0,0,0,.44.5h6.12a.45.45,0,0,0,.44-.5A3.54,3.54,0,0,0,17.5,18.47Z"
  })]
}), 'DiscussionIcon');